/**
 * Composable for smooth scrolling to elements
 */
export const useScrollTo = () => {
  const scrollToSection = (targetId, options = {}) => {
    // Only run on client side
    if (process.client) {
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          ...options
        });
      }
    }
  };

  // Make the function available globally for onclick handlers
  if (process.client && typeof window !== 'undefined') {
    window.scrollToSection = scrollToSection;
  }

  return {
    scrollToSection
  };
};
